import PosthogService from '~/services/posthog/PosthogService';
import { POSTHOG_EVENTS } from '~/services/posthog/events';

/**
 * Fires when the office confirms Log Out in the confirmation dialog.
 * Event: office:logout:confirmed
 *
 * The legacy name is kept verbatim: the series is live, and renaming it would
 * fork every insight built on it.
 */
export function fireOfficeLogoutConfirmed(): void {
  PosthogService.getInstance().track(POSTHOG_EVENTS.OFFICE_LOGOUT_CONFIRMED);
}
